// App.js
// import React from 'react';
// import './App.css';
// import MaintenancePage from './pages/MaintenancePage';

// function App() {
//   return <MaintenancePage />;
// }

// export default App;


import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
  Outlet
} from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

// pages
import HomePage from './pages/HomePage';
import BookingStepper from './components/BookingStepper';
import ConfirmationPage from './pages/ConfirmationPage';
import CancelPage from './pages/CancelPage';
import AdminDashboard from './pages/AdminDashboard';
import AboutPage from './pages/AboutPage';
import HamburgerMenu from './components/HamburgerMenu';
import AdminLogin from './pages/AdminLogin';
import ScrollToTop from './utils/ScrollToTop';
import FaqPage from './pages/FaqPage';
import MaintenancePage from "./pages/MaintenancePage";

// tiny guard (reads token from localStorage for now)
function AdminGuard() {
  const token = localStorage.getItem('adm_t');
  return token ? <Outlet /> : <Navigate to="/admin/login" replace />;
}

const pageVariants = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 }
};
const pageTransition = { type: 'tween', ease: 'easeInOut', duration: 0.5 };

function AnimatedRoutes() {
  const location = useLocation();
  const hideMenu = /^\/(booking|confirmation|cancel)(\/|$)/i.test(location.pathname);

  return (
    <ThemeProvider theme={theme}>
      <AnimatePresence mode="wait">
        {!hideMenu && <HamburgerMenu />}
        <ScrollToTop />
        <Routes location={location} key={location.pathname}>
          {/* public routes */}
          <Route
            path="/"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <HomePage />
              </motion.div>
            }
          />
          <Route
            path="/booking"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <BookingStepper />
              </motion.div>
            }
          />
          <Route
            path="/confirmation"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <ConfirmationPage />
              </motion.div>
            }
          />
          <Route
            path="/cancel"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <CancelPage />
              </motion.div>
            }
          />

          {/* about, admin, etc... */}
          <Route
            path="/about"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <AboutPage />
              </motion.div>
            }
          />
          <Route
            path="/faq"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <FaqPage />
              </motion.div>
            }
          />
          <Route
            path="/admin/login"
            element={
              <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                <AdminLogin />
              </motion.div>
            }
          />
          <Route element={<AdminGuard />}>
            <Route
              path="/admin"
              element={
                <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={pageTransition}>
                  <AdminDashboard />
                </motion.div>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
    </ThemeProvider>
  );
}

function App() {
  const maintenanceMode = false;

  if (maintenanceMode) {
    return <MaintenancePage />;
  }

  return <AnimatedRoutes />;
}

export default App;